// extracted by mini-css-extract-plugin
export var categoryIcon = "_c2-5";
export var connectorContainer = "_c2-1";
export var connectorLine = "_c2-0";
export var minHeight0 = "_c2-6";
export var relativeUnitValueSelector = "_c2-2";
export var trifoldSelectorBody = "_c2-4";
export var trifoldSelectorList = "_c2-3";